import infoIcon from "../../assets/design-revamp/info-icon.svg";

const InfoIcon = ({ style }) => {
  return (
    <>
      <div>
        <img
          className=""
          src={infoIcon}
          alt=""
          style={{ ...style, width: "20px", height: "20px" }}
        />
      </div>
    </>
  );
};

export default InfoIcon;
